import type { CoverageLine } from './coverage.types';

/**
 * Where each surface sends the reader. Kept in one module so the tile, the
 * rows and the bands cannot drift onto different routes for the same thing.
 */

export const ALL_COVERAGE_HREF = '/customer/policies';

export const policyHref = (line: CoverageLine): string =>
  line.reference
    ? `${ALL_COVERAGE_HREF}?search=${encodeURIComponent(line.reference)}`
    : ALL_COVERAGE_HREF;

/**
 * The approval flow branches again inside the quote pages when the signed-in
 * user is not the quote's named contact, so this only has to get the reader to
 * the right quote.
 */
export const quoteHref = (line: CoverageLine): string => {
  if (!line.id) {
    return ALL_COVERAGE_HREF;
  }

  return line.isRenewal
    ? `/customer/quotes/${line.id}/renewals/${line.product}/approve`
    : `/customer/quotes/${line.id}/approve/${line.product}`;
};

export const coverageHref = (line: CoverageLine): string =>
  line.kind === 'quote' ? quoteHref(line) : policyHref(line);
